// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".meta-item[data-v-583a96b4]{padding:.25rem 0;white-space:break-spaces;font-size:.75rem;font-weight:400;text-align:center;color:#666}@media(min-width:48rem){.meta-item[data-v-583a96b4]{font-size:.875rem}}.meta-item__title[data-v-583a96b4]{color:#c4c4c4}.meta-item__north[data-v-583a96b4]{display:flex;align-items:center;margin-top:.625rem;min-width:17.5rem}", ""]);
// Exports
module.exports = exports;
